<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['ecm-list-doc', getSelectedDEV && 'dev-selected-component']">
    <v-data-table v-model="selected" :headers="headers" :items="items" item-key="id" :search="search" v-bind="schema.attributesTable">
      <template v-slot:top>
        <v-card-title class="pt-1 elevation-0">
          <span v-if="schema.attributes.title">ECM</span>
          <v-spacer></v-spacer>
          <v-btn @click="openLightgallery()" class="mr-5 mt-3" small color="primary" :disabled="disableActions">Visualizar todos</v-btn>
          <v-btn @click="openModal('new')" class="mr-5 mt-3" small color="primary" :disabled="disableActions"> <v-icon>add</v-icon>Novo </v-btn>
          <v-btn v-if="selected.length" @click="downloadItems()" class="mr-5 mt-3" color="primary" small :disabled="disableActions"
            >Baixar Selecionados</v-btn
          >
          <v-text-field clearable v-model="search" append-icon="search" label="Pesquisar..." single-line hide-details></v-text-field>
        </v-card-title>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="d-flex justify-center table-actions">
          <v-icon color="green" class="mr-2" @click="openModal('edit', item)">create</v-icon>
          <v-icon color="blue" class="mr-2" @click="download(item)">save_alt</v-icon>
          <v-icon color="red darken-3" v-if="schema.attributes.excludeItem" @click="deleteItem(item)">delete_forever</v-icon>
        </div>
      </template>
    </v-data-table>

    <div class="list-images-lightgallery"></div>

    <v-dialog v-model="showDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ readOnly ? 'Editar Documento ECM' : 'Novo Documento ECM' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="saveDocuments" :disabled="!isValid && !readOnly">{{ readOnly ? 'Alterar' : 'Salvar' }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
          <v-row>
            <v-col sm="4">
              <v-select
                v-model="document.id_document_group"
                :items="id_document_group_items"
                item-text="documentGroupName"
                item-value="idDocumentGroup"
                label="Grupo de documento"
                @change="handleId_document_group"
              ></v-select>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="document.id_tp_document"
                :items="id_tp_document_items"
                label="Tipo de documento"
                item-text="documentTypeName"
                item-value="idDocumentType"
                @change="handleId_tp_document"
              ></v-select>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="document.id_tp_dom_document"
                :items="id_tp_dom_document_items"
                label="Tipo dom de documento"
                item-text="domTypeDocumentName"
                item-value="idDomTypeDocument"
                @change="handleId_tp_dom_document"
              ></v-select>
            </v-col>
            <v-col sm="3">
              <v-text-field v-model="document.nr_reference" label="Número de Referência"></v-text-field>
            </v-col>
            <v-col sm="2">
              <v-menu v-model="document.datemenu">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="document.dt_document" v-on="on" label="Data do documento"></v-text-field>
                </template>
                <v-date-picker v-model="document.dt_document"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="7">
              <v-text-field v-model="document.tag" label="Tag"></v-text-field>
            </v-col>
            <v-col sm="12">
              <v-textarea v-model="document.observation" label="Observação"></v-textarea>
            </v-col>
          </v-row>
          <v-row v-if="readOnly">
            <v-col cols="3">
              <v-hover v-slot:default="{ hover }" v-if="document.content">
                <v-card :elevation="hover ? 12 : 2" width="250" dark color="primary">
                  <v-img :src="document.content">
                    <v-row v-if="hover" align="center" justify="center" class="hover-card-image">
                      <v-col cols="12">
                        <v-card-text class="text-h5 font-weight-bold">Arquivo</v-card-text>
                        <v-card-text>{{ document.fileName }}</v-card-text>
                        <v-card-text class="font-weight-bold">{{ document.kBytesNumber }}</v-card-text>
                      </v-col>
                    </v-row>
                  </v-img>
                </v-card>
              </v-hover>

              <v-card v-else min-width="250" dark color="primary">
                <v-card-title class="text-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon large left v-on="on">{{ document.contentType }}</v-icon>
                    </template>
                    <span>{{ document.fileName }}</span>
                  </v-tooltip>
                  <span class="text-h6 font-weight-light">{{ document.kBytesNumber }}</span>
                </v-card-title>
                <v-card-text class="font-weight-bold">{{ document.fileName }}</v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <i4pro-file-upload-list
                v-if="showDialog"
                @add-file="addFile"
                @remove-file="removeFile"
                :attributes="schema.attributesFiles"
              ></i4pro-file-upload-list>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ECM from '@/services/ecm';
import { abstractField } from 'vue-form-generator';
import { getIcon, formatBytes, downloadFile } from '@/helpers/utils';
import Swal from 'sweetalert2';
import 'lightgallery.js';
import 'lg-zoom.js';
import moment from 'moment';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],
  components: {
    i4proDialog: () => import('@/components/dialogs/i4pro-dialog'),
    i4proFileUploadList: () => import('@/components/inputs/i4pro-file-upload-list')
  },

  data() {
    return {
      showDialog: false,
      isValid: false,
      search: '',
      selected: [],
      EcmKey: '',
      readOnly: false,
      disableActions: true,
      headers: [
        {
          text: 'Grupo',
          align: 'left',
          sortable: true,
          value: 'groupName'
        },
        { text: 'Tipo', value: 'documentType', sortable: true },
        { text: 'Nome', value: 'documentFile', sortable: true },
        { text: 'Tamanho', value: 'kBytesNumber', sortable: true },
        { text: 'Data Gravação', value: 'saveDate', sortable: true },
        { text: '', value: 'action', sortable: false }
      ],
      items: [],
      id_document_group_items: [],
      id_tp_document_items: [],
      id_tp_dom_document_items: [],
      document: {
        id_document_group: '',
        id_tp_document: '',
        id_tp_dom_document: '',
        nr_reference: '',
        dt_document: '',
        tag: '',
        observation: '',
        files: []
      }
    };
  },

  async mounted() {
    const { data } = await ECM.GetKey(this.schema.domain);

    this.EcmKey = data;

    if (this.model[this.EcmKey]) {
      this.getDocuments();
      this.disableActions = false;
    }
  },

  methods: {
    async handleId_document_group() {
      const { data } = await ECM.GetDocumentType(this.document.id_document_group);

      this.id_tp_document_items = data;
      this.document.id_tp_document = '';
      this.document.id_tp_dom_document = '';

      this.handleIsValid();
    },

    async handleId_tp_document() {
      const { data } = await ECM.GetDomDocumentType(this.document.id_tp_document);

      this.id_tp_dom_document_items = data;
      this.document.id_tp_dom_document = '';

      this.handleIsValid();
    },

    async deleteItem(item) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: `v-btn v-size--default primary`,
          cancelButton: `v-btn v-size--default error`
        },
        buttonsStyling: false
      });

      const result = await swalWithBootstrapButtons.fire({
        title: 'Deseja realmente excluir esse documento?',
        text: '',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      });

      if (result.value) {
        try {
          const { data } = await ECM.DeleteDocument(this.getHash(item));

          this.$store.dispatch('notification/showNotification', {
            color: 'success',
            text: 'Documento excluído com sucesso',
            showIconNotification: false
          });

          this.getDocuments();
        } catch (err) {
          this.$store.dispatch('notification/showNotification', {
            color: 'error',
            text: err,
            showIconNotification: false
          });
        }
      }
    },

    async download(item) {
      const { data } = await ECM.DownloadDocument(this.getHash(item));

      downloadFile(data.content, data.contentType, data.fileName.split('.').pop(), data.fileName.split('.').shift());
    },

    async downloadItems() {
      const { data } = await ECM.DownloadDocuments(
        this.selected.map(item => item.id),
        this.selected.map(item => item.hash)
      );

      downloadFile(data.content, data.contentType, data.fileName.split('.').pop(), data.fileName.split('.').shift());
    },

    async getDocuments() {
      const { data } = await ECM.GetDocuments(this.schema.domain, this.model[this.EcmKey]);

      for (let item in data) {
        data[item].saveDate = this.formatDate(data[item].saveDate);
        data[item].kBytesNumber = formatBytes(data[item].kBytesNumber);
        data[item].tag = this.formatTag(data[item].tag);
      }

      this.items = data;

      let firstImage = true;

      if (this.items.length) {
        for (let i in this.items) {
          if (this.items[i].contentType.startsWith('image')) {
            let tagA = document.createElement('a');
            tagA.id = this.items[i].id;
            tagA.setAttribute('hash', this.items[i].hash);
            const { data: dataImage } = await ECM.ReturnImageContent(this.getHash(this.items[i]));
            tagA.href = dataImage;
            document.querySelector('.list-images-lightgallery').appendChild(tagA);
            firstImage = false;
          }
        }

        window.lightGallery(document.querySelectorAll(`.list-images-lightgallery`)[0], {
          thumbnail: false
        });
      }
    },

    async loadImage(item) {
      if (item.detail.index === 0) return;

      let element = document.querySelectorAll('.list-images-lightgallery > a')[item.detail.index];

      const { data } = await ECM.ReturnImageContent(element.id, element.getAttribute('hash'));

      document.getElementById(element.id).href = data;

      var lg = document.querySelectorAll(`.list-images-lightgallery`)[0];

      lightGallery(lg);
    },

    async openModal(mode, item) {
      const { data: dataGetDocumentGroup } = await ECM.GetDocumentGroup(this.schema.domain);
      this.id_document_group_items = dataGetDocumentGroup;

      if (mode === 'edit') {
        const { data: dataGetDocumentDetail } = await ECM.GetDocumentDetail(this.getHash(item));

        this.document.id_document_group = dataGetDocumentDetail.idDocumentGroup;
        await this.handleId_document_group();

        this.document.id_tp_document = dataGetDocumentDetail.idDocumentType;
        await this.handleId_tp_document();

        this.document.id_tp_dom_document = dataGetDocumentDetail.idDocumentDomainType;
        this.document.nr_reference = dataGetDocumentDetail.referenceNumber;
        this.document.dt_document = this.formatDate(dataGetDocumentDetail.documentDate);
        this.document.tag = dataGetDocumentDetail.tagName;
        this.document.observation = dataGetDocumentDetail.observation;
        this.document.contentType = this.setIcon(dataGetDocumentDetail.contentType);
        this.document.fileName = dataGetDocumentDetail.fileName;
        this.document.kBytesNumber = formatBytes(dataGetDocumentDetail.kBytesNumber);
        (this.document.documentId = item.id), (this.document.hash = item.hash), (this.readOnly = true);

        if (dataGetDocumentDetail.contentType.startsWith('image')) {
          const { data: dataReturnImageContent } = await ECM.ReturnImageContent(this.getHash(item));
          this.document.content = dataReturnImageContent;
        }
      }

      this.showDialog = true;
    },

    async save() {
      const { userName } = await this.$store.getters['authentication/getUser'];
      const { status } = await ECM.InsertDocument(this.document, this.schema.domain, this.model[this.EcmKey], userName);

      if (status === 200) {
        this.$store.dispatch('notification/showNotification', {
          color: 'success',
          text: 'Documentos adicionados com sucesso',
          showIconNotification: false
        });
        this.getDocuments();
      }

      this.clearDocumentItems();
      this.clearDocument();
      this.showDialog = false;
      this.isValid = false;
    },

    async update() {
      const { userName } = await this.$store.getters['authentication/getUser'];
      const { status } = await ECM.UpdateDocument(this.document);

      if (status === 200) {
        this.$store.dispatch('notification/showNotification', {
          color: 'success',
          text: 'Documento alterado com sucesso',
          showIconNotification: false
        });
        this.getDocuments();
      }

      this.clearDocumentItems();
      this.clearDocument();
      this.showDialog = false;
      this.isValid = false;
    },

    async saveDocuments() {
      if (this.readOnly) this.update();
      else this.save();
    },

    handleId_tp_dom_document() {
      this.handleIsValid();
    },

    handleIsValid() {
      if (this.document.id_document_group && this.document.id_tp_document && this.document.id_tp_dom_document && this.document.files.length)
        this.isValid = true;
      else this.isValid = false;
    },

    clearDocumentItems() {
      this.id_document_group_items = [];
      this.id_tp_dom_document_items = [];
      this.id_tp_document_items = [];
    },

    clearDocument() {
      this.document = {
        id_document_group: '',
        id_tp_document: '',
        id_tp_dom_document: '',
        nr_reference: '',
        dt_document: '',
        tag: '',
        observation: '',
        files: []
      };
    },

    openLightgallery() {
      document.querySelectorAll('.list-images-lightgallery a')[0].click();
    },

    closeModal() {
      this.clearDocumentItems();
      this.clearDocument();
      this.showDialog = false;
      this.isValid = false;
      this.readOnly = false;
    },

    setIcon(type) {
      return getIcon(type);
    },

    getHash(item) {
      let hash = item.id.toString().padStart(9, '0');

      return `${hash}${item.keyValues}`;
    },

    addFile(items) {
      this.document.files = items;
      this.handleIsValid();
    },

    removeFile(items) {
      this.document.files = items;
      this.handleIsValid();
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    formatTag(tags) {
      return tags ? tags.toLocaleString() : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.v-responsive__content {
  transition: 300ms;
  .hover-card-image {
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.6);
    transition: 300ms;

    div {
      color: #fff;
      text-align: center;
      padding: 0 0 10px 0;
    }
  }
}

.ecm-list-doc {
  position: relative;
}

.btn-close {
  position: absolute;
  top: 51%;
  right: 30px;
  color: var(--v-error-darken2);
  font-size: 30px;
  cursor: pointer;
  font-size: 24px !important;
  z-index: 100;
  opacity: 0;
}

.table-actions {
  i {
    font-size: 20px !important;
  }
}

.list-images-lightgallery {
  display: none;
}

@keyframes opacity {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
